import axios from "axios";
import { api_base_url } from "../../environment.jsx";

const apiClient = axios.create({
  baseURL: api_base_url,
  headers: { "Content-Type": "application/json" },
});

// Attach JWT token to every request
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("dcms_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// On 401 redirect to login (skip for the login endpoint itself)
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const isLoginRequest = error.config?.url?.includes("/api/Auth/login");
    if (error.response?.status === 401 && !isLoginRequest) {
      localStorage.removeItem("dcms_token");
      window.location.href = "/signin";
    }
    return Promise.reject(error);
  }
);

export default apiClient;
